import s from '~/utils/s'

const url = process.env.NUXT_ENV_API_BROWSER_URL_SF || 'http://localhost:9997/api'

export default function ({ $axios, store }) {
  const api = $axios.create({
    baseURL: url
  })

  $axios.onResponseError((error) => {
    const original = error.config
    const code = error.response.status

    if (code === 401) {
      if (!s(store).auth.isTokenRefreshInProcess) {
        try {
          return new Promise((resolve, reject) => {
            s(store).auth.setTokenRefreshFlag(true)

            const storeAuthToken = s(store).auth.sfToken
            const storeRefreshToken = s(store).auth.refreshToken

            // ? debug purpose
            // let reachableCookieAuthToken = 1
            // let reachableCookieRefreshToken = 2
            // const reachableCookies = store.$cookies.get('ga-cookies')
            // if (reachableCookies) {
            //   reachableCookieAuthToken = reachableCookies.auth?._sfToken
            //   reachableCookieRefreshToken = reachableCookies.auth?._refreshToken
            // }

            // console.group('Запрос обновления токена')
            // console.log('Исполнение на клиенте?', process.client)
            // console.log('Auth token from store and cookies equal?', storeAuthToken === reachableCookieAuthToken)
            // console.log('Refresh token from store and cookies equal?', storeRefreshToken === reachableCookieRefreshToken)
            // console.log('Auth token from store (s(store).auth)', storeAuthToken)
            // console.log('Refresh token from store (s(store).auth)', storeRefreshToken)
            // console.log('Auth token from cookie (store.$cookie)', reachableCookieAuthToken)
            // console.log('Refresh token from cookie (store.$cookie)', reachableCookieRefreshToken)
            // console.groupEnd()

            api.post(`${url}/refresh-token`, {}, {
              headers: {
                Authorization: `Bearer ${storeAuthToken}`,
                'x-refresh-token': storeRefreshToken
              }
            })
              .then((res) => {
                if (!res || !res.data) reject(api(original))

                const { result } = res.data
                const { rt, jwt } = result

                s(store).auth.setSfTokenAction({ token: jwt, refreshToken: rt })

                // ! Эта часть дублировала cookie
                // const cookies = store.$cookies.get('ga-cookies')
                // if (cookies) {
                //   cookies.auth._sfToken = jwt
                //   cookies.auth._refreshToken = rt
                //   store.$cookies.set('ga-cookies', cookies)
                // }

                original.headers.Authorization = `Bearer ${jwt}`
                original.headers['x-refresh-token'] = `${rt}`

                // console.group('Выполнение изначального 401 запроса с новыми токенами', original)
                // console.log('Новый токен авторизации: ', jwt)
                // console.log('Новый токен обновления: ', rt)
                // console.log('Исполнение на клиенте?', process.client)
                // console.log('Auth token from store and cookies equal?', storeAuthToken === reachableCookieAuthToken)
                // console.log('Refresh token from store and cookies equal?', storeRefreshToken === reachableCookieRefreshToken)
                // console.log('Auth token from store (s(store).auth)', storeAuthToken)
                // console.log('Refresh token from store (s(store).auth)', storeRefreshToken)
                // console.log('Auth token from cookie (store.$cookie)', reachableCookieAuthToken)
                // console.log('Refresh token from cookie (store.$cookie)', reachableCookieRefreshToken)
                // console.groupEnd()

                resolve(api(original))
              })
              .catch(async (ex) => {
                s(store).auth.clearUserData()
                const result = await store.$api.getAuthorizeToken()

                if (result && result.data.token) {
                  const newAuthToken = result.data.token
                  s(store).auth.setAuthorizeTokenAction(newAuthToken)
                  original.headers.Authorization = `Bearer ${newAuthToken}`
                  resolve(api(original))
                } else {
                  reject(api(original))
                }
              })
              .finally(() => s(store).auth.setTokenRefreshFlag(false))
          })
        } catch (ex) {
          console.error('Ошибка при выполнение оригинального запроса на обновление токена: ', ex)
        }
      } else {
        try {
          return new Promise((resolve, reject) => {
            const intervalId = setInterval(() => {
              if (!s(store).auth.isTokenRefreshInProcess) {
                const storeAuthToken = s(store).auth.sfToken
                const storeRefreshToken = s(store).auth.refreshToken

                // ? debug purpose
                // let reachableCookieAuthToken = 1
                // let reachableCookieRefreshToken = 2
                // const reachableCookies = store.$cookies.get('ga-cookies')
                // if (reachableCookies) {
                //   reachableCookieAuthToken = reachableCookies.auth?._sfToken
                //   reachableCookieRefreshToken = reachableCookies.auth?._refreshToken
                // }
                
                original.headers.Authorization = `Bearer ${storeAuthToken}`
                original.headers['x-refresh-token'] = storeRefreshToken

                // console.group('Повтор запроса из очереди')
                // console.log('Исполнение на клиенте?', process.client)
                // console.log('Auth token from store and cookies equal?', storeAuthToken === reachableCookieAuthToken)
                // console.log('Refresh token from store and cookies equal?', storeRefreshToken === reachableCookieRefreshToken)
                // console.log('Auth token from store (s(store).auth)', storeAuthToken)
                // console.log('Refresh token from store (s(store).auth)', storeRefreshToken)
                // console.log('Auth token from cookie (store.$cookie)', reachableCookieAuthToken)
                // console.log('Refresh token from cookie (store.$cookie)', reachableCookieRefreshToken)
                // console.groupEnd()

                clearInterval(intervalId)
                resolve(api(original))
              }
            }, 100)
          })
        } catch (ex) {
          console.error('Ошибка при выполнение запроса из списка ожидания: ', ex)
        }
      }
    }
  })
}
